/**
 * Name of the group used for the grid helper elements.
 * Exclude from rendering texture
 */
const GRID_HELPER = 'gridHelperGroup';

/**
 * Group name use to store every element constituting the final image
 * this group will also be used to apply gutting path to the entire image
 * @note this doesn't include globa background and grid elements (see gridHelper)
 */
const CUTTING_GROUP_NAME = 'cuttingGroup';

const CUTTING_OUTLINE_NAME = 'cuttingPathOutline';

/**
 * Name of the group used for the locked background elements.
 * Always background
 */
const LOCKED_BACKGROUND_GROUPD_NAME = 'lockedBackgroundObjectGroup';

/**
 * Name of the group used as Front Group elements
 */
const LOCKED_FOREGROUND_GROUP_NAME = 'lockedForegroundObjectGroup';

const WORKING_ZONE_NAME = 'workingZoneGroup';

const BACKGROUND_MASK_NAME = 'backgroundMask';

export {
    BACKGROUND_MASK_NAME,
    CUTTING_GROUP_NAME,
    CUTTING_OUTLINE_NAME,
    GRID_HELPER,
    LOCKED_BACKGROUND_GROUPD_NAME,
    LOCKED_FOREGROUND_GROUP_NAME,
    WORKING_ZONE_NAME,
};
